import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { TranslationLanguage } from '../translation/translation';
import { User } from './user';

export class UserInput extends User implements EntityInput<User> {
  forCreate() {
    return { ...this };
  }

  forUpdate() {
    return { ...this };
  }

  forDelete() {
    return { ...this };
  }

  validate() {
    if (!this.firstName) return false;
    if (!this.lastName) return false;

    return true;
  }

  hasChanges(original: User | undefined) {
    if (!original) return true;

    if (this.firstName !== original.firstName) return true;
    if (this.lastName !== original.lastName) return true;
    if (this.language !== original.language) return true;
    if (this.locale !== original.locale) return true;
    if (this.profilePicture !== original.profilePicture) return true;

    return false;
  }

  withFirstName(firstName: string) {
    this.firstName = firstName;
    return cloneDeep(this);
  }

  withLastName(lastName: string) {
    this.lastName = lastName;
    return cloneDeep(this);
  }

  withProfilePicture(profilePicture?: string) {
    this.profilePicture = profilePicture;
    return cloneDeep(this);
  }

  withLanguage(language: TranslationLanguage | undefined) {
    this.language = language;
    return cloneDeep(this);
  }

  withLocale(locale: string | undefined) {
    this.locale = locale;
    return cloneDeep(this);
  }
}

export class CreateUserInput extends forCreate(User) {}

export class UpdateUserInput extends forUpdate(User) {}

export class DeleteUserInput extends forDelete(User) {}
